// Common functions for the mosaic_v2 CompositeView.
import { $ } from 'global/globals';
import _ from 'global/underscore';

export function childViewOptions(gon) {
    return {
        initialLength: this.initialLength || 0,
        isInfiniteLoad: gon.display_options && gon.display_options.infiniteLoadMore,
        photoQuality: gon.display_options && gon.display_options.photoQuality || 'default'
    };
}

export function behaviors() {
    let behaviorHash = {
        CollectionVote: {}
    };

    // for backwards compatibility with widgets that are already out in the wild
    if (!_.isFalsy(this.options.displayOptions.headerOptions)) {
        behaviorHash.AppendUploaderTiles = {};
        if (this.options.displayOptions.headerOptions.layout === 'tile') {
            behaviorHash.Upload = {};
        }
    }
    return behaviorHash;
}

// Resizes the header if there's anything in the collection.
export function onRender() {
    if (this.collection.length) {
        resizeHeader.call(this);
    }
}

// Resizes the header. Called by the tablet view.
// TODO: make this use this.$ instead of global jQuery.
export function resizeHeader() {
    const $large = $('.large');
    const largeOuterWidth = $large.outerWidth(true);
    const largeWidth = $large.outerWidth();

    this.maxOuterPhotoWidth = (this.maxOuterPhotoWidth < largeOuterWidth) ? largeOuterWidth : this.maxOuterPhotoWidth;
    this.maxPhotoWidth = (this.maxPhotoWidth < largeWidth) ? largeWidth : this.maxPhotoWidth;

    const mosaicWidth = $('.mosaic_frame').outerWidth(true);
    const numberOfItemPerLine = Math.floor(mosaicWidth / this.maxOuterPhotoWidth);
    const margin = this.maxOuterPhotoWidth - this.maxPhotoWidth;
    const width = (this.maxOuterPhotoWidth * numberOfItemPerLine) - margin;

    $('#widget_header').width(width - 10);
    $('#interactive_section').width(width - 10);
    $('ul.clearfix').width(width);
    $('#header_wrapper').css('visibility', 'visible');
}

export function onInitMosaicCalculations() {
    // If infinite load completely randomize the mosaic
    if (!this.runMosaicCalculation) {
        //if we overwrite the collection, we need to carry over the reviewSelectionOptions
        var reviewSelectionOptions = this.collection.reviewSelectionOptions;
        this.collection = this.collectionQueue;
        this.collection.reviewSelectionOptions = reviewSelectionOptions;

        this.collection.on('sync', () => { this.initialLength = this.collection.length });
    } else {
        // Otherwise perfect load each mosaic page
        this.collectionQueue.on('sync', () => {
            if (this.collectionQueue.currentPage === 1) {
                this.collection.reset();
            }
            this.initialLength = this.collection.length;
            setTimeout(() => {
                this.safariTimeOut = 0;
                if (this._isRendered) {
                    this.onCalculatePerfectMosaic();
                    this.runMosaicCalculation = false;
                }
                this.collectionHasSynced = true;
            }, this.safariTimeOut);
        });
    }
}



// Shows the "Load more" button.
export function showLoadMore() {
    this.$el.find('#mosaic_control').show();
}

// Hides the "load more" button.
export function hideLoadMore() {
    this.$el.find('#mosaic_control').hide();
}
